var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 62,
    viewBox: "0 0 178 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.1508 18.4028C76.1922 18.4028 72.3343 17.8393 68.3801 17.8393C54.6751 17.8393 41.4697 18.0437 27.8713 19.8115C20.4212 20.78 1.27394 24.869 1.38722 36.4345C1.5005 48 11 52 11 52C11 52 15 54.5 27.8713 57C40 59.3558 44.5 59.8065 53.5 60C79.2374 60.5535 104.013 58.0321 129.738 56.595C139.305 56.0605 150.038 55.5059 159.259 52.8071C163.87 51.4574 168.607 50.2798 172.563 47.4226C182.496 40.249 171.317 30.3617 164.111 26.7299C131.601 10.3449 93.3463 5.25964 57.6111 1.49805",
    stroke: "#2F2F37",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircul);
export default __webpack_public_path__ + "static/media/circul.4451be1bcd4508f5ac30f0e11b3713f8.svg";
export { ForwardRef as ReactComponent };